export default __webpack_public_path__ + "static/media/img4.40c86346.png";